import {
  defaultSystemCode,
  exists,
  SystemCode,
  SystemCodeFromJSON
} from '@/api'

import { dateToPlainFormat } from '@/utils'
import { BibliographyClass, CollectionFlag, Prefix } from '@/types'
export interface LendCollection {
  id: number // 資料ID
  collectionNo: string
  bibliographyId: number
  bibliographyClass: BibliographyClass
  prefix: Prefix
  searchType: SystemCode
  displayTitle: string
  displayAuthor: string
  appendixCode: SystemCode
  lendTime: string
  lendType: SystemCode
  collectionType: SystemCode
  shelfType: SystemCode
  ndc: string
  branch: SystemCode
  reserveCount: number
  dueDate: string
  extendCount: number
  remindCount: number
  message: string
  collectionFlag: CollectionFlag
  appendixLendFlag: boolean
  revision: number
  // 下記はタブ「今回の貸出資料」で値を表示するために使用する
  handlingType: SystemCode
  collectionStatus: SystemCode
  workMemo: string
  displayMemo: string
  localMemo: string
  hasReservation: boolean
  hasReserveForwarding: boolean
  lendUserId: string
  // 下記はレシート「貸出状況票」印刷で貸出分類ごとの貸出点数を算出するために使用する
  lendClassification: string
}

export function LendCollectionFromJSON(json: any): LendCollection {
  return {
    id: exists(json, 'id') ? json.id : 0,
    collectionNo: exists(json, 'collection_no') ? json.collection_no : '',
    bibliographyId: exists(json, 'bibliography_id') ? json.bibliography_id : 0,
    bibliographyClass: exists(json, 'bibliography_class')
      ? json.bibliography_class
      : BibliographyClass.Real,
    prefix: exists(json, 'prefix') ? json.prefix : Prefix.Set,
    searchType: exists(json, 'search_type')
      ? SystemCodeFromJSON(json.search_type)
      : defaultSystemCode(),
    displayTitle: exists(json, 'display_title') ? json.display_title : '',
    displayAuthor: exists(json, 'display_author') ? json.display_author : '',
    appendixCode: exists(json, 'appendix_code')
      ? SystemCodeFromJSON(json.appendix_code)
      : defaultSystemCode(),
    lendTime: exists(json, 'lend_time')
      ? dateToPlainFormat(json.lend_time)
      : '',
    lendType: exists(json, 'lend_type')
      ? SystemCodeFromJSON(json.lend_type)
      : defaultSystemCode(),
    collectionType: exists(json, 'collection_type')
      ? SystemCodeFromJSON(json.collection_type)
      : defaultSystemCode(),
    shelfType: exists(json, 'shelf_type')
      ? SystemCodeFromJSON(json.shelf_type)
      : defaultSystemCode(),
    ndc: exists(json, 'ndc') ? json.ndc : '',
    branch: exists(json, 'branch')
      ? SystemCodeFromJSON(json.branch)
      : defaultSystemCode(),
    reserveCount: exists(json, 'reserve_count') ? json.reserve_count : 0,
    dueDate: exists(json, 'due_date') ? dateToPlainFormat(json.due_date) : '',
    extendCount: exists(json, 'extend_count') ? json.extend_count : 0,
    remindCount: exists(json, 'remind_count') ? json.remind_count : 0,
    message: exists(json, 'message') ? json.message : '',
    collectionFlag: exists(json, 'collection_flag')
      ? json.collection_flag
      : CollectionFlag.NotCollection,
    appendixLendFlag: exists(json, 'appendix_lend_flag')
      ? json.appendix_lend_flag
      : false,
    revision: exists(json, 'revision') ? json.revision : 0,
    handlingType: exists(json, 'handling_type')
      ? SystemCodeFromJSON(json.handling_type)
      : defaultSystemCode(),
    collectionStatus: exists(json, 'collection_status')
      ? SystemCodeFromJSON(json.collection_status)
      : defaultSystemCode(),
    workMemo: exists(json, 'work_memo') ? json.work_memo : '',
    displayMemo: exists(json, 'display_memo') ? json.display_memo : '',
    localMemo: exists(json, 'local_memo') ? json.local_memo : '',
    hasReservation: exists(json, 'has_reservation')
      ? json.has_reservation
      : false,
    hasReserveForwarding: exists(json, 'has_reserve_forwarding')
      ? json.has_reserve_forwarding
      : false,
    lendUserId: exists(json, 'lend_user_id') ? json.lend_user_id : '',
    lendClassification: exists(json, 'lend_classification')
      ? json.lend_classification
      : ''
  }
}
